import {Component, OnInit, ViewChild} from '@angular/core';
import {PaginatorState} from 'primeng/paginator';
import {CustomInput} from '../../Components/input/custom-input';
import {Button} from '../../Components/button/button';
import {CartItem, ProductCartService} from '../product-cart-component/product-cart-service';
import {SpinnerOverlayService} from '../../Components/spinner/spinner-overlay.service';
import {ITEMS_PER_PAGE} from '../../core/config/pagination.constants';
import {ProductCatalogService} from '../product-catalog/product-catalog.service';
import {ProductDetailDialog} from '../product-detail-dialog/product-detail-dialog';
import {MatDialog} from '@angular/material/dialog';
import {MessageService} from '../../shared/message.service';
import {TableLazyLoadEvent, TableModule} from 'primeng/table';
import {ActivatedRoute, Router} from '@angular/router';
import {AccountService} from '../../login/account.service';
import {ItemService} from '../../entities/item/item-list/item.service';

@Component({
  selector: 'app-related-items',
  imports: [CustomInput, Button, TableModule],
  templateUrl: './related-items.html',
  styleUrls: ['./related-items.css']
})
export class RelatedItems implements OnInit {

  @ViewChild('customTable') itemTable!: any;
  searchTerm: string = '';
  itemList: CartItem[] = []

  totalItems: number = 0
  item: string = ''
  first = 0;
  rows = ITEMS_PER_PAGE;
  page = 0;
  lastEvent: any;
  loading = false;

  constructor(
    private spinner: SpinnerOverlayService,
    private productCatalogService: ProductCatalogService,
    private dialog: MatDialog,
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private productCart: ProductCartService,
    private accountService: AccountService,
    private itemService: ItemService
  ) {
  }

  ngOnInit() {
    this.findRelatedItemsByParams();
  }

  onSearch(event: PaginatorState) {
    console.log('Searching for:', this.searchTerm);

    this.first = event.first ?? 0;
    this.rows = event.rows ?? ITEMS_PER_PAGE;
    this.page = Math.floor((this.first ?? 0) / (this.rows ?? ITEMS_PER_PAGE));

    if (this.itemTable) {
      this.itemTable.reset();
    }

    this.findRelatedItemsByParams()

  }

  findRelatedItemsByParams() {
    this.handleLoading(true);

    const cartItems = this.productCart.getCart();
    const itemIds = cartItems.map(item => item.id);
    const itemIdsUnique = [...new Set(itemIds)];
    const customerAN = this.accountService.userIdentity()?.user.addressNumber;

    const params = {
      itemIds: itemIdsUnique.join(','),
      criteria: this.searchTerm,
    };

    this.productCatalogService.findRelatedItemsByItemIds(params, customerAN).subscribe({
      next: (response: any) => {
        const allItems = response.body?.items?.itemList ?? [];
        this.totalItems = response.body?.items?.totalCount ?? 0;
        // Paginación en frontend
        const start = this.first;
        const end = this.first + this.rows;
        this.itemList = allItems.slice(start, end);
        this.handleLoading(false);
      },
      error: () => {
        this.handleLoading(false);
      }
    });
  }

  findItemsByParams() {
    this.handleLoading(true)

    const cartItems = this.productCart.getCart();
    const itemIds = cartItems.map(item => item.id);
    console.log('Cart item IDs:', itemIds)

    const itemIdsUnique = [...new Set(itemIds)];
    const customerAN = this.accountService.userIdentity()?.user.addressNumber;

    const params = {
      itemIds: itemIdsUnique.join(',')
    }

    this.productCatalogService.findRelatedItemsByItemIds(params, customerAN).subscribe({
      next: (response: any) => {
        const allItems = response.body?.items?.itemList ?? [];
        this.totalItems = response.body?.items?.totalCount ?? 0;
        // Paginación en frontend
        const start = this.first;
        const end = this.first + this.rows;
        this.itemList = allItems.slice(start, end);
        this.handleLoading(false)
      },
      error: () => {
        this.handleLoading(false)
      }
    })
  }

  handleLoading(loading: boolean) {
    this.loading = loading;
    if (loading) this.spinner.show(); else this.spinner.hide();
  }

  openProductDetailDialog(product: CartItem) {
    if (!product.productId) {
      this.messageService.showError("Error: El producto no cuenta con un identificador, por favor, contactar con soporte");
      return;
    }
    this.dialog.open(ProductDetailDialog, {
      panelClass: 'lexend-dialog',
      data: {
        id: product.productId,
        readOnly: true,
        skipFindById: true,
        preselectedItem: product,
        preselected: {
          dimensions: product.dimensions,
          thickness: product.thickness,
          color: product.color,
          texture: product.texture,
          faceOne: product.faceOne,
          faceTwo: product.faceTwo,
          quantity: product.quantity,
          platformCount: 0,
          halfPlatformCount: 0,
          quarterPlatformCount: 0,
          eighthPlatformCount: 0
        }
      },
      width: '900px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: true
    });
  }

  loadItems(event: TableLazyLoadEvent) {
    if (JSON.stringify(event) === JSON.stringify(this.lastEvent)) {
      return;
    }
    this.lastEvent = event;

    this.page = Math.floor((event.first ?? 0) / (event.rows ?? ITEMS_PER_PAGE));
    this.rows = event.rows ?? ITEMS_PER_PAGE;

    this.findItemsByParams();
  }

  showCatalog() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {related: false},
      queryParamsHandling: 'merge',
    });
  }

  cleanFilter() {
    this.searchTerm = '';
    this.findItemsByParams()
  }

  getProductCoating(product: CartItem): string {
    if (product.faceOne && !product.faceTwo) return '1 Cara';
    if (!product.faceOne && product.faceTwo) return '2 Caras';
    return 'Sin definir';
  }

}
